import { SALE_API_URL } from "../../../constants";
import { apiSlice } from "../../../services";
import type {
    IDeleteProductAliasReq,
    IDeleteProductAliasRes,
    IGetAllOrgLangsReq,
    IGetAllOrgLangsRes,
    IGetItemReq,
    IGetItemRes,
    IGetProductAliasesReq,
    IGetProductAliasesRes,
    IUpdateItemsOrderReq,
    IUpdateItemsOrderRes,
    IUpdateProductAliasesReq,
    IUpdateProductAliasesRes,
} from "../types/interfaces";

const itemApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getCategoryItems: builder.query<IGetItemRes, IGetItemReq>({
            query: (reqBody) => ({
                url: `${SALE_API_URL}/categories/${reqBody.category_id}/items`,
                method: "GET",
            }),
            providesTags: ["SalesItems"],
        }),
        getAllOrgLangs: builder.query<IGetAllOrgLangsRes, IGetAllOrgLangsReq>({
            query: (reqBody) => ({
                url: `${SALE_API_URL}/orgs/${reqBody.org_id}/languages`,
                method: "GET",
            }),
            providesTags: ["OrgLanguages"],
        }),
        updateItemsOrder: builder.mutation<IUpdateItemsOrderRes<null>, IUpdateItemsOrderReq>({
            query: (reqBody) => ({
                url: `${SALE_API_URL}/categories/${reqBody.category_id}/items_order`,
                method: "PUT",
                body: { new_order: reqBody.order },
            }),
            invalidatesTags: ["SalesItems"],
        }),

        // 取得商品別名（新 API）
        getProductAliases: builder.query<IGetProductAliasesRes, IGetProductAliasesReq>({
            query: (reqBody) => ({
                url: `${SALE_API_URL}/products/${reqBody.item_id}/aliases`,
                method: "GET",
            }),
            providesTags: (result, error, arg) => [{ type: "ProductAliases", id: arg.item_id }],
        }),

        // 創建/更新商品別名（新 API）
        updateProductAliases: builder.mutation<IUpdateProductAliasesRes, IUpdateProductAliasesReq>({
            query: (reqBody) => ({
                url: `${SALE_API_URL}/products/${reqBody.item_id}/aliases`,
                method: "PUT",
                body: { aliases: reqBody.aliases },
            }),
            invalidatesTags: (result, error, arg) => [{ type: "ProductAliases", id: arg.item_id }],
        }),

        // 刪除商品別名（新 API）
        deleteProductAlias: builder.mutation<IDeleteProductAliasRes, IDeleteProductAliasReq>({
            query: (reqBody) => ({
                url: `${SALE_API_URL}/products/${reqBody.item_id}/aliases`,
                method: "DELETE",
            }),
            invalidatesTags: (result, error, arg) => [{ type: "ProductAliases", id: arg.item_id }],
        }),
    }),
});

export const {
    useGetCategoryItemsQuery,
    useGetAllOrgLangsQuery,
    useUpdateItemsOrderMutation,
    // 商品別名相關 hooks（新 API）
    useGetProductAliasesQuery,
    useUpdateProductAliasesMutation,
    useDeleteProductAliasMutation,
} = itemApiSlice;
